module.exports = __webpack_public_path__ + "img/heatcad.3b8af47a.png";